import { createContext, useContext } from 'react';

import { RangeValues } from 'utils/addin/sankey';

type SankeyExcelBindingState = {
  hasExcelBindingInThisSheet: boolean;
  bindingAddress: string | undefined;
  selectedAddress: string | undefined;
  selectedValues: RangeValues | undefined;
  isRangeSelectionValid: boolean;
  bindDiagramToCurrentExcelSelection: (sankeyId: number) => Promise<void>;
  selectDiagramBindingCells: (sankeyId: number) => Promise<void>;
};

export const SankeyExcelBindingContext = createContext<SankeyExcelBindingState>(
  {
    hasExcelBindingInThisSheet: false,
    bindingAddress: undefined,
    selectedAddress: undefined,
    selectedValues: undefined,
    isRangeSelectionValid: false,
    bindDiagramToCurrentExcelSelection: async () => {},
    selectDiagramBindingCells: async () => {},
  }
);

export const useSankeyExcelBindingContext = () =>
  useContext(SankeyExcelBindingContext);
